/** Request a bounded display variant without changing external or authored asset URLs. */
export function appIcon(source: string, size: 64 | 128): string {
  try {
    const url = new URL(source, 'http://app.invalid')
    if (!/^\/v1\/apps\/[^/]+\/icon$/.test(url.pathname)) return source
    url.searchParams.set('size', String(size))
    return source.startsWith('/')
      ? `${url.pathname}${url.search}${url.hash}`
      : url.href
  } catch {
    return source
  }
}
